module.exports = __webpack_public_path__ + "img/logo.755918e6.png";